import React, { Component } from 'react'
import {
  authenticateAndDeleteProvider,
  stopConfirmingDeletion
} from 'sharedservices/provider/actions'
import {
  providerAuthenticationFormPassword,
  selectedProviderLink,
  selectedProviderName,
  uri
} from 'sharedservices/provider/subs'

import Dialog from './Dialog'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import t from 'translate'

class Delete extends Component {
  static propTypes = {
    companyKey: PropTypes.string.isRequired
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.authenticateAndDeleteProvider(
      this.props.uri,
      this.props.selectedProviderLink,
      this.props.password
    )
  }

  render() {
    const title = t('Delete shared service provider {0}?', [
      this.props.selectedProviderName
    ])

    const warning = t('Verify your password to confirm deletion')

    return (
      <Dialog
        modalTitle={title}
        headerText={warning}
        submitButtonText={t('Delete')}
        onCancel={this.props.onCancel}
        onSubmit={this.handleSubmit}
        store={this.props.store}
        companyKey={this.props.companyKey}
      />
    )
  }
}

const mapDbToProps = (db, props) => ({
  selectedProviderName: selectedProviderName(db, props.companyKey),
  password: providerAuthenticationFormPassword(db),
  selectedProviderLink: selectedProviderLink(db, props.companyKey),
  uri: uri(db, props.companyKey)
})

const mapActionsToProps = (dispatch, initialProps) => ({
  onCancel: () => dispatch(stopConfirmingDeletion(initialProps.companyKey)),
  authenticateAndDeleteProvider: (uri, selectedLink, password) => {
    dispatch(
      authenticateAndDeleteProvider(initialProps.companyKey, uri, selectedLink, password)
    )
  }
})

export default connect(mapDbToProps, mapActionsToProps)(Delete)
